import { render, staticRenderFns } from "./DDropdown.vue?vue&type=template&id=868e5360&scoped=true&"
import script from "./DDropdown.vue?vue&type=script&lang=js&"
export * from "./DDropdown.vue?vue&type=script&lang=js&"
import style0 from "./DDropdown.vue?vue&type=style&index=0&id=868e5360&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "868e5360",
  null
  
)

export default component.exports